import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SeoDataProvider } from './contexts/SeoDataContext';
import CustomCodeInjector from './Components/CustomCodeInjector';
import { attachPhoneClickTracking } from './utils/analytics';

import { ThemeProvider } from "@material-tailwind/react";

attachPhoneClickTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SeoDataProvider>
        <CustomCodeInjector />
        <BrowserRouter basename="/">
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </SeoDataProvider>
    </HelmetProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
